module.exports = __webpack_public_path__ + "static/media/grayEdit.e555204c.svg";